module.exports = __webpack_public_path__ + "img/alarmPushRecord.84b159dc.jpg";